import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SwiperContainer } from 'swiper/element';
import { A11y, Autoplay } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types/swiper-options';
import {
  DealerDataService,
  ProductAvailability,
} from '../../../dealer-data.service';

@Component({
  selector: 'widget-display-products',
  templateUrl: './display-products.component.html',
  styleUrls: ['./display-products.component.scss'],
})
export class DisplayProductsComponent implements OnInit, OnDestroy {
  @Input() widget: any;

  @ViewChild('swiper') swiper?: ElementRef<SwiperContainer>;

  products: any[] = [];
  swiperConfig!: SwiperOptions;
  private _unsub = new Subject<void>();

  constructor(private _svc: DealerDataService) {}

  ngOnInit(): void {
    const availability: ProductAvailability =
      this.widget?.availability || 'in_stock';
    const limit = this.widget?.numberOfProducts || 3;
    const productType = this.widget?.productType;
    const sortBy = this.widget?.sort_by;
    this._svc
      .getProducts(availability, 1, limit, productType, sortBy)
      .pipe(takeUntil(this._unsub))
      .subscribe((r: any) => {
        this.products = r?.data || [];
      });

    this.swiperConfig = this._buildSwiperConfig();
  }

  ngOnDestroy(): void {
    this._unsub.next();
    this._unsub.complete();
  }

  get title(): string {
    return this.widget?.Title || this.widget?.title || '';
  }

  get isSlider(): boolean {
    return this.widget?.display_mode === 'slider';
  }

  get columns(): number {
    return this.widget?.product_columns || 3;
  }

  slidePrev(): void {
    this.swiper?.nativeElement.swiper.slidePrev();
  }

  slideNext(): void {
    this.swiper?.nativeElement.swiper.slideNext();
  }

  private _buildSwiperConfig(): SwiperOptions {
    return {
      modules: [Autoplay, A11y],
      loop: true,
      navigation: false,
      spaceBetween: 24,
      slidesPerView: 1,
      breakpoints: {
        580: { slidesPerView: 2 },
        900: { slidesPerView: this.columns },
      },
      autoplay: {
        delay: 4000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      },
    };
  }
}
